"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitials = void 0;
const splitUserName = (userName) => {
    return userName
        .split(" ")
        .map((namePart) => {
        // Return empty string if name only contains special characters
        if (namePart.match(/[0-9a-z]/i) === null) {
            return "";
        }
        const matches = namePart.match(/(\w|-|')+/g);
        return matches === null ? "" : matches.join("-");
    })
        .filter(Boolean);
};
const getInitials = (fullName) => {
    const nameParts = fullName
        ? splitUserName(fullName).map((name) => name.charAt(0).toUpperCase())
        : [];
    if (nameParts.length === 0) {
        return "";
    }
    return `${nameParts[0]}${nameParts.length > 1 ? nameParts[nameParts.length - 1] : ""}`;
};
exports.getInitials = getInitials;
//# sourceMappingURL=getInitials.js.map